import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f77933e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6f77933e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77933e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PersonaliseBundle: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/PersonaliseBundle.vue').default,Personalise: require('/nfs_storage_drive/xen1.powertext.co.uk/servers/togglenode1/webstore/components/Personalise.vue').default})
